import { render, staticRenderFns } from "./TransferTaskDialogue.vue?vue&type=template&id=2b1a3628&scoped=true"
import script from "./TransferTaskDialogue.vue?vue&type=script&lang=js"
export * from "./TransferTaskDialogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a3628",
  null
  
)

export default component.exports